<template>
  <div ref="columns" class="nav-pane columns is-multiline">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NavPane',

  mounted() {
    this.resizeContainer()
    window.addEventListener('resize', this.resizeContainer, { passive: true })
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeContainer, {
      passive: true
    })
  },

  methods: {
    resizeContainer() {
      // A flex container in column-direction does not expand to accommodate additional columns.
      // Workaround for - https://stackoverflow.com/questions/33891709/when-flexbox-items-wrap-in-column-mode-container-does-not-grow-its-width
      if (this.$refs.columns.scrollWidth > this.$refs.columns.offsetWidth) {
        // 29.75px is the padding of the nav-pane container + the children (ul)
        this.$refs.columns.style.width = `${
          this.$refs.columns.scrollWidth + 29.75
        }px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-pane {
  background-color: $white;
  flex-direction: column;
  margin-left: 0;
  margin-right: 0;
  padding: 10px;

  @include tablet {
    max-height: 600px;
  }

  @include desktop {
    max-height: 360px;
  }
}
</style>
